<template>
    <div class="pastime-notification" :class="{ 'type-error' : msgType == 'error', 'type-info' : msgType == 'info' }" id="pastimeNotification">
        <i :class="[ msgType == 'success' ? 'ecom-sucess' : 'ecom-info']"/>
        <div class="content">
            <p class="notification-description">  {{ msgText }} </p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Notifications',
    components: {},
    props: {
        msgType: {type: String, default: 'info'},
        msgText: {type: String, default: ''},
    },
    data() {
        return {
            //data1: null,
        };
    },
    computed: {
        // fix naming font ecom-success, its "ecom-sucess in prod O_O"
        type() {
            return this.msgType == 'success' ? 'sucess' : this.msgType;
        },
    },
    watch: {
        //watched1(value) { },
    },
    created() {
    },
    mounted() {
        
    },
    methods: {
        //method1() { },
    },
};
</script>

<style scoped>

</style>